import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { LoadSlotChangesServiceResponse } from "./loadSlotChanges.service";

export const loadSlotChangesEndpoint = (params: string): AxiosPromise<LoadSlotChangesServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/loadSlotChanges?${params}`);
